import { render, staticRenderFns } from "./gDialog.vue?vue&type=template&id=53501089&scoped=true&"
import script from "./gDialog.vue?vue&type=script&lang=js&"
export * from "./gDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53501089",
  null
  
)

export default component.exports